import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import Input from "../ui/inputs/Input";
import CheckboxSmall from "../ui/checkboxs/CheckboxSmall";

export default class PassengerFields extends ComponentBase
{
  twzipcode: any;

  constructor(elem: ComponentElem, needAddress: boolean, needBodyInfo: boolean)
  {
    super(elem);
    this.setupAddress(needAddress);
    this.setupBodyInfo(needBodyInfo);
    this.setupIdInput();
  }

  setupIdInput()
  {
    let idInput: Input = (this.$root.find(`[data-field="id_number"] [component="input"]`)[0] as ComponentElem)._component,
      checkbox: CheckboxSmall = (this.$root.find(`.id-number-checkbox`)[0] as ComponentElem)._component;

    checkbox.emitter.on("change", (checked: boolean) =>
    {
      idInput.changePattern(checked ? "passport" : "person_id");
      idInput.setMaxLength(checked ? 9 : 10);
      idInput.setPlaceholder(checked ? "例：31234567" : "例：A123456789")
    });
    checkbox.update();
  }

  setupAddress(needAddress: boolean)
  {

    if (needAddress) {
      let $countySelect = this.$root.find(`[data-role="county"]`),
        $districtSelect = this.$root.find(`[data-role="district"]`);



        this.twzipcode = new window.TWzipcode(this.$root[0], {
        combine: false,
        county: {
          onChange: () =>
          {
            if (this.twzipcode.get().county) {
              $districtSelect.prepend(`<option value="" disabled>鄉鎮市區</div>`);
            }
          }
        }
      });

      ///@ts-ignore
      $countySelect[0]._twzipcode = this.twzipcode;
      ///@ts-ignore
      $districtSelect[0]._twzipcode = this.twzipcode;
    }
    else {
      let $fields = this.$root.find(`[data-group="address"]`);
      $fields.attr("hidden", "true");
    }    

    this.twzipcode;
  }

  setupBodyInfo(needBodyInfo: boolean)
  {
    if (!needBodyInfo) {
      // this.$root.find(`[data-field="height"]`).attr("hidden", "true");
      // this.$root.find(`[data-field="weight"]`).attr("hidden", "true");
      this.$root.find(`[data-group="body_info"]`).attr("hidden", "true");
    }
  }
}